import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import NewsletterSection from "../home/components/NewsletterSection";
import CCHero from "./components/CCHero";
import CCSubcategories from "./components/CCSubcategories";
import CCPostGrid from "./components/CCPostGrid";
import CCCrossLink from "./components/CCCrossLink";

export default function CozyCorners() {
  return (
    <div className="bg-[#FAF7F0] min-h-screen">
      <Navbar />
      <CCHero />
      <CCSubcategories />
      <CCPostGrid />
      <CCCrossLink />
      <NewsletterSection />
      <Footer />
    </div>
  );
}
